import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";

const AthleteAcknowledgedModal = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <Modal
      className="athlete-acknowledged-modal"
      title={t("athleteAcknowledgedModal.title")}
    >
      <div className="body">
        <p className="p1">{t("athleteAcknowledgedModal.body")}</p>
      </div>
      <footer id="confirmation-modal-footer">
        <button
          type="button"
          data-button-type="primary"
          onClick={() => {
            submit("/actions/refresh?", {
              method: "GET",
              body: { "modal[type]": "" },
            });
          }}
        >
          <span>{t("athleteAcknowledgedModal.gotIt")}</span>
        </button>
      </footer>
    </Modal>
  );
};

export default AthleteAcknowledgedModal;
